import asyncEachLimit from 'async/eachLimit';

export default { sendFile, sendParts };

const PUT_TIMEOUT = 2 * 60 * 1000;
const MULTI_LIMIT = 10;

export function sendFile(params: any, done: (err: any, body: string) => void) {
  const { request, file, progress } = params;

  request.url = request.url.replace(
    'lax-proxy-03.storagesvc.sohonet.com',
    'lax-proxy-03.ares-dev.com'
  );

  Object.keys(request.headers).forEach((key) => {
    const key_lc = key.toLowerCase();
    if (key_lc === 'host' || key_lc === 'content-length') {
      delete request.headers[key];
    }
  });
  const opts = {
    method: request.method,
    url: request.url,
    headers: request.headers,
    body: file,
    timeout: PUT_TIMEOUT,
    progress,
  };
  _request(opts, done);
}
export function sendParts(params: any, done: (err: any, body: string) => void) {
  const { part_list, upload_list, file, progress } = params;

  const chunk_size = part_list[0].part_size;
  const req_list = upload_list.map((upload, i) => {
    const index = part_list.findIndex(
      (part) => part.part_hash === upload.part_hash
    );
    const part = part_list[index];
    const start_pos = index * chunk_size;
    const part_file = file.slice(start_pos, start_pos + part.part_size);
    return { request: upload.signed_opts, file: part_file };
  });
  asyncEachLimit(
    req_list,
    MULTI_LIMIT,
    (req, done) => sendFile({ ...req, progress }, done),
    done
  );
}
function _request(params: any, done: (err: any, body: string) => void) {
  let is_done = false;
  function request_done(err: any, result?: any) {
    if (!is_done) {
      is_done = true;
      done(err, result);
    }
  }
  const { method, url, headers, body, timeout, progress } = params;
  const xhr = new XMLHttpRequest();
  if (timeout) {
    xhr.timeout = timeout;
  }
  xhr.onload = () => {
    let status = xhr.status === 1223 ? 204 : xhr.status;
    let ret_body = false;
    let err: any = null;

    ret_body = xhr.response || xhr.responseText;
    if (status < 100 || status > 599) {
      err = 'bad_status';
    } else if (status > 399) {
      err = status;
    }
    request_done(err, ret_body);
  };
  xhr.onerror = () => {
    request_done('xhr_error');
  };
  xhr.ontimeout = () => {
    request_done('timeout');
  };
  xhr.open(method, url, true);
  for (let name in headers) {
    xhr.setRequestHeader(name, headers[name]);
  }
  let last_loaded = 0;
  if (progress) {
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable) {
        const delta = e.loaded - last_loaded;
        const fraction = e.loaded / e.total;
        last_loaded = e.loaded;
        progress(fraction, delta, e.loaded);
      }
    };
  }
  xhr.send(body);
}
